module.exports = __webpack_public_path__ + "img/dp158_06.a4ed9eac.jpg";